// extracted by mini-css-extract-plugin
export default {"JobDetailContainer":"JobDetailPage_JobDetailContainer__jKGXD","container":"JobDetailPage_container__TRMBL"};